const INVALID_NUMBER = "Invalid Number";

const isValidNumber = function(value) {
  const parsed = Number(value);
  return !Number.isNaN(parsed);
};

export default { INVALID_NUMBER, isValidNumber };
